import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import UpdatePrivateDiNumber from "./UpdatePrivateDiNumber";
import AddTKCSOrderNumber from "./AddTKCSOrderNumber";
import { sweetAlert } from "../../Common/Utills/Utills";
import * as XLSX from "xlsx";

const ViewTKCSOrderDetails = () => {
  const navigate = useNavigate();
  const params = useParams();
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [privateDetails, setPrivateDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowId, setRowId] = useState("");
  const [rowData, setRowData] = useState([]);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(
    startItem + privateDetails?.length - 1,
    totalRecords
  );
  const [orderData, setOrderData] = useState([]);
  const order_id = params.order_id;
  const [filterCriteria, setfilterCriteria] = useState({
    private_order_details_id: parseInt(order_id) || "",
  });

  const handleNavigate = () => {
    navigate(-1);
  };

  const exportToExcel = (rowData) => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert rowData to a worksheet
    const ws = XLSX.utils.json_to_sheet(
      rowData.map((item, index) => ({
        "S.NO": (currentPage - 1) * pageSize + index + 1,
        "DI Number": item?.di_number,
        "DI Date": item?.di_date,
        "Last Date of DI": item?.last_date_di,
        "Di Quantity": item?.di_qty,
        "Inspected Quantity": item.total_inspection_qty,
        "Order Balance": item.order_balance,
        "Order Value": item.cost,
        "Order Value (GST Inclusive)": item.cost_with_gst,
        "Payment Remark": item.payment_status ? item.payment_status : "-",
      }))
    );

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "TKCS Order DI Details");

    // Export the workbook
    XLSX.writeFile(wb, "TKCS_Order_DI_Details.xlsx");
  };

  const getSingleData = async () => {
    let BASE_URL =
      SERVER_URL +
      `/api/private-order/single-private-order-details/${user_id}/${order_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setOrderData(result.data);
    } else {
      setOrderData([]);
    }
  };
  const getData = async () => {
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );

    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    let BASE_URL =
      SERVER_URL + `/api/private-order/all-private-di-numbers/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      // setTotalRecords(result.total);
      setRowData(result.data);
    } else {
      setRowData([]);
    }
  };
  const deleteOrderNumberData = async (order_id) => {
    const message = "Do you want to delete this TKCS order number!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL =
      SERVER_URL +
      `/api/private-order/private-di-number/${user_id}/${order_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
    }
  };
  useEffect(() => {
    if (filterCriteria.private_order_details_id) {
      getData();
    }
  }, [filterCriteria]);
  useEffect(() => {
    if (order_id) {
      getSingleData();
    }
  }, [order_id]);
  const addDataToModal = (id) => {
    setRowId(id);
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            View TKCS Order Number &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleNavigate}
              >
                <i
                  className="mdi mdi-arrow-left"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
                Back{" "}
              </button>
            </span>
          </div>
          <div className="form-container">
            <form className="form-sample">
              {/* <p className="card-description">Personal info</p> */}
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="Circle">Circle</label>
                    <input
                      type="text"
                      className="form-control"
                      name="circle"
                      id="Circle"
                      value={orderData?.circle}
                      readOnly
                      placeholder="Circle"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="Size">Size</label>
                    <input
                      type="text"
                      className="form-control"
                      name="product_name"
                      id="Size"
                      value={orderData?.product_name}
                      readOnly
                      placeholder="Size"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="po_qty">
                      Offer Quantity For Inspection
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="po_qty"
                      id="po_qty"
                      value={orderData?.po_qty}
                      readOnly
                      placeholder="Offer Quantity For Inspection"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="pole_date">Rate</label>
                    <input
                      type="text"
                      className="form-control"
                      name="date"
                      id="pole_date"
                      value={orderData?.rate}
                      readOnly
                      placeholder="Pole Date"
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="terms">GST %</label>
                    <input
                      type="text"
                      className="form-control"
                      name="gst_percent"
                      id="terms"
                      value={orderData?.gst_percent}
                      readOnly
                      placeholder="Payment Terms"
                    />
                  </div>
                </div>
                {orderData?.product_quantity_details?.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="quantity">Po Quantity</label>
                          <input
                            type="text"
                            className="form-control"
                            name="pole-qty"
                            id="quantity"
                            value={item?.po_qty}
                            readOnly
                            placeholder="Pole Quantity"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="Pole">Pole Size</label>
                          <input
                            type="text"
                            className="form-control"
                            name="pole_size"
                            id="Pole"
                            value={item?.size}
                            readOnly
                            placeholder="Pole Size"
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

              {/* <button className="btn btn-primary mr-2 mt-3" type="submit">
              Save
            </button> */}
            </form>
          </div>
        </div>
      </div>

      <div className="card mt-2">
        <div className="card-body">
          {/* <div className="card-title">
            TKCS Order Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                // onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div> */}
          <div className="table_btn">
            <div
              className="mb-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add TKCS Order Number
              </button>
              <button
                className="btn btn-outline-excel  ml-2"
                onClick={() => exportToExcel(rowData)}
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-excel" />
                </span>
                Export to Excel
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
              }}
            ></div>
          </div>
          <div className="private-table-container">
            <div
              className="table-responsive table-bordered govt-table"
              style={{ border: "0.05px solid lightGray", width: "auto" }}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>DI Number</th>
                    <th>DI Date</th>
                    <th>Last Date of DI</th>
                    {/* <th style={{ textAlign: "center" }}>Order Details</th> */}
                    <th>Di Quantity</th>
                    <th>Inspected Quantity</th>
                    <th>Order Balance</th>
                    <th>Order Value</th>
                    <th>Order Value (GST Inclusive)</th>
                    <th>Remark</th>
                    <th style={{ textAlign: "center" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rowData && rowData?.length > 0 ? (
                    rowData?.map((item, index) => (
                      <React.Fragment key={index}>
                        <tr>
                          {/* <td style={{ padding: "10px" }}>{index + 1}</td> */}
                          <td style={{ padding: "10px" }}>
                            {(currentPage - 1) * pageSize + index + 1}
                          </td>
                          <td>{item.di_number}</td>
                          <td>{item.di_date}</td>
                          <td>{item.last_date_di}</td>
                          {/* <td style={{ padding: "0px" }}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              {item.order_details.map(
                                (orderDetail, orderIndex) => (
                                  <tr key={orderIndex}>
                                    <td>{orderDetail.yard_name}</td>
                                    <td>{orderDetail.company_name}</td>
                                    <td>{orderDetail.inspection_qty}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </td> */}
                          <td>{item.di_qty}</td>
                          <td>{item.total_inspection_qty}</td>
                          <td>{item.order_balance}</td>
                          <td>{item?.cost}</td>
                          <td>{item?.cost_with_gst}</td>
                          <td>
                            {item.payment_status ? item.payment_status : "-"}
                          </td>
                          <td
                            style={{
                              padding: "10px",
                              verticalAlign: "middle",
                              textAlign: "center",
                            }}
                          >
                            <span>
                              <button
                                className="btn btn-outline-secondary btn-sm ml-2"
                                onClick={() => addDataToModal(item.id)}
                                data-toggle="modal"
                                data-target="#updateDiNumber"
                              >
                                <i className="mdi mdi-note-edit-outline" />
                              </button>{" "}
                              <button
                                className="btn btn-outline-danger btn-sm ml-2"
                                onClick={() => deleteOrderNumberData(item.id)}
                              >
                                <i className="mdi mdi-delete" />
                              </button>
                            </span>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">
                        <div className="loading-container">
                          <p>No row to show</p>
                        </div>
                      </td>
                    </tr>
                  )}
                  <tr className="total-row">
                    <td colSpan={4} className="total-cell">
                      Total
                    </td>
                    <td>
                      {rowData?.reduce(
                        (total, item) => total + parseInt(item.di_qty),
                        0
                      )}
                    </td>
                    <td>
                      {rowData?.reduce(
                        (total, item) =>
                          total + parseInt(item.total_inspection_qty),
                        0
                      )}
                    </td>
                    <td>
                      {rowData.length > 0 &&
                        rowData[rowData.length - 1].order_balance}
                    </td>
                    <td>
                      {rowData?.reduce(
                        (total, item) => total + parseInt(item.cost),
                        0
                      )}
                    </td>
                    <td>
                      {rowData?.reduce(
                        (total, item) => total + parseInt(item.cost_with_gst),
                        0
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <AddTKCSOrderNumber
          getData={getData}
          private_order_details_id={orderData.id}
        />
        <UpdatePrivateDiNumber
          getData={getData}
          setRowId={setRowId}
          rowId={rowId}
          size={orderData?.order_details}
          private_order_details_id={orderData.id}
        />
      </div>
    </>
  );
};

export default ViewTKCSOrderDetails;
